import { frontendURL } from '../../../../helper/URLHelper';
import { hasOnboardingChannelReturn } from '../../../../helper/onboardingChannelReturn';
import { ONBOARDING_CHANNEL_DETOUR_ROUTE_NAMES } from '../../../../helper/onboardingRouteGuard';
import channelFactory from './channel-factory';

const SettingsContent = () => import('../Wrapper.vue');
const SettingWrapper = () => import('../SettingsWrapper.vue');
const InboxHome = () => import('./Index.vue');
const Settings = () => import('./Settings.vue');
const InboxChannel = () => import('./InboxChannels.vue');
const ChannelList = () => import('./ChannelList.vue');
const AddAgents = () => import('./AddAgents.vue');
const FinishSetup = () => import('./FinishSetup.vue');
const ChoosePlatform = () => import('./ChoosePlatform.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/inboxes'),
      component: SettingWrapper,
      children: [
        {
          path: '',
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'settings_inbox_list',
          component: InboxHome,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/inboxes'),
      component: SettingsContent,
      props: params => {
        const showBackButton = params.name !== 'settings_inbox_list';
        // The primary/secondary nav this icon toggles is itself hidden for
        // the whole onboarding channel detour (see Dashboard.vue's
        // isOnboardingChannelDetour) — showing a toggle for a sidebar that
        // isn't rendered is a dead control across every channel type that
        // goes through this shared wrapper (Lazada, Facebook Messenger,
        // etc.), not just one step.
        const isOnboardingChannelDetour =
          ONBOARDING_CHANNEL_DETOUR_ROUTE_NAMES.includes(params.name) &&
          hasOnboardingChannelReturn(params.params.accountId);
        return {
          headerTitle: 'INBOX_MGMT.HEADER',
          headerButtonText: 'SIDEBAR.NEW_INBOX',
          icon: 'mail-inbox-all',
          newButtonRoutes: ['settings_inbox_list'],
          showBackButton,
          showSidemenuIcon: !isOnboardingChannelDetour,
        };
      },
      children: [
        {
          path: 'new',
          component: InboxChannel,
          children: [
            {
              path: '',
              name: 'settings_inbox_new',
              component: ChannelList,
              meta: {
                permissions: ['administrator'],
              },
            },
            {
              path: ':inbox_id/finish',
              name: 'settings_inbox_finish',
              component: FinishSetup,
              meta: {
                permissions: ['administrator'],
              },
            },
            {
              path: ':sub_page',
              name: 'settings_inboxes_page_channel',
              component: channelFactory.create(),
              meta: {
                permissions: ['administrator'],
              },
              props: route => {
                return { channel_name: route.params.sub_page };
              },
            },
            {
              path: ':inbox_id/agents',
              name: 'settings_inboxes_add_agents',
              meta: {
                permissions: ['administrator'],
              },
              component: AddAgents,
            },
            {
              path: ':inbox_id/choose-platform',
              name: 'settings_inboxes_choose_platform',
              meta: {
                permissions: ['administrator'],
              },
              component: ChoosePlatform,
            },
          ],
        },
        {
          path: ':inboxId',
          name: 'settings_inbox_show',
          component: Settings,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
